/**
 * error_message.js - SMS認証を行うページのエラー文言の管理を行う
 *     対象チケット : MYSB_EXT-3900
 *     build対象
 *
 */
module.exports = {
  text: {
    'validate-sbid-password-change': {
      message: [
        'パスワードを英数字、記号8～16文字で入力してください',
      ],
      display: false
    },
    'validate-confirm-number': {
      message: [
        '確認番号を数字6桁で入力してください',
      ],
      display: false
    },
    'validate-mobile-number': {
      message: [
        '数字11桁で入力してください',
      ],
      display: false
    },
    'validate-password': {
      message: [
        '英数字8桁以上で入力してください',
      ],
      display: false
    },
    'validate-password-dup': {
      message: [
        '確認のため再度パスワードを入力してください',
      ],
      display: false
    },
    'validate-password-format': {
      message: [
        '半角英字と数字を組み合わせてください（8桁以上）',
      ],
      display: false
    },
    'validate-security-number': {
      message: [
        'セキュリティ番号を数字3桁で入力してください',
      ],
      display: false
    },
    'validate-secret-number': {
      message: [
        '数字4桁で入力してください',
      ],
      display: false
    },
    'validate-numeric-only': {
      message: [
        '数字11桁以上で入力してください',
      ],
      display: false
    },
  },
  radio: {

  },
  select: {
    'birthday-year': {
      message: [
        '生年月日の「年」を選択してください'
      ],
      display: false
    },
    'birthday-month': {
      message: [
        '生年月日の「月」を選択してください'
      ],
      display: false
    },
    'birthday-day': {
      message: [
        '生年月日の「日」を選択してください'
      ],
      display: false
    },
  }
}



// WEBPACK FOOTER //
// ./src/shared/error_message.js